export default "__VITE_ASSET__DRYFVgb0__"